/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_TitleInputs */

const cs_settings_office_title = /** @type {(inputs: Settings_Office_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kancelář`)
};

const en_settings_office_title = /** @type {(inputs: Settings_Office_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office`)
};

/**
* | output |
* | --- |
* | "Office" |
*
* @param {Settings_Office_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_title = /** @type {((inputs?: Settings_Office_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_title(inputs)
	return cs_settings_office_title(inputs)
});